const GET_TASK = `
  query GetTask($id: uuid!) {
    task: tasks_by_pk(id: $id) {
      createdAt: created_at
      name
      details
      paidAt: paid_at
      startDate: start_date
      status {
        name
        textColor: text_color
      }
    }
  }
`

export default GET_TASK
